module.exports = __webpack_public_path__ + "static/media/aws-codebuild.ec02f523.svg";